// Toggle class trigger.
const toggle_trigger = (btn, target, className) => {
	btn.addEventListener('click', (e) => {
		e.preventDefault();
		target.classList.toggle(className);
	}) 
}

const featureButton = ( selector = null ) => {
	const reviewItems = document.querySelectorAll(selector);
	if (!reviewItems ) return;

	reviewItems.forEach(item => {
		const toggleFeatureBtn = item.querySelectorAll('.features-btn')

		if ( !toggleFeatureBtn) return;

		toggleFeatureBtn.forEach(btn => {
			toggle_trigger(btn, item, 'show-features')
		})
	})
}

/**
 * Toggle top 10 chart disclaimer.
 * @returns void
 */
const toggle_disclaimer = () => {
	const disclaimers = document.querySelectorAll('.disclaimer-box')
	// Exit as soon as possible.
	if ( !disclaimers ) return;

	disclaimers.forEach( disclaimer => {
		const trigger = disclaimer.querySelector('.dis-trigger');
		// Exit if disclaimer is hidden.
		if ( !trigger ) return;

		toggle_trigger(trigger, disclaimer, 'open');
	})
}

document.addEventListener("DOMContentLoaded", () => {
	featureButton('.review-item')
	toggle_disclaimer()
})
